<template>
    <div>

        <div class="col-xs-12 spacer-form text-center">
            <strong><h4>{{'Exit Voucher'|trans}}</h4></strong>
        </div>

        <div class="alert alert-info" v-if="job.workerIntervention.fails.failId===4">
            {{"In spite of everything, please fill in the order form so that we can claim a fair amount from the client"|trans}}
        </div>

        <p class="conditions" v-if="voucher.workTimeEnd">
            <strong>
                {{'Depart Hour'|trans}} {{voucher.workTimeEnd|DateFormat('H:mm')}} {{ }}
            </strong>
        </p>

        <div class="white-block">
            <strong>
                {{ job.jobTypesChainTranslated.join(' > ') }}. {{ job.jobDescription }}
            </strong>
        </div>
        <table class="table table-voucher disabled-workforce" v-bind:class="{ active: voucher.quarterOfHour.enabledWorkForce }">

            <tbody>
                <tr>
                    <td colspan="3"><span class="text-bold">{{'Workforce :'|trans}}</span></td>
                    <td></td>
                </tr>
                <tr v-if="voucher.quarterOfHour.enabledWorkForce===false">
                    <td colspan="3" >
                        <strong>{{ "workforce according to contract"|trans }}</strong>
                    </td>
                    <td>
                        <button v-on:click="voucher.quarterOfHour.enabledWorkForce = !voucher.quarterOfHour.enabledWorkForce" class="btn btn-sm  small-btn-with-icon"  v-bind:class="{ 'red-a': voucher.quarterOfHour.enabledWorkForce}">
                            <i class="fa fa-trash " v-if="voucher.quarterOfHour.enabledWorkForce"></i>
                            <i class="fa fa-square-o " v-if="!voucher.quarterOfHour.enabledWorkForce"></i>
                        </button>
                    </td>
                </tr>

                <!-- BY QUARTER HOUR PRICE CALCULATION -->
                <tr v-if="voucher.pricePolicyHourCalculation === 'byQuarterOfHour' && voucher.quarterOfHour.enabledWorkForce " >
                    <td  width="30%">
                        <input type="text" v-model="voucher.quarterOfHour.title" class="form-control" v-bind:disabled="!voucher.quarterOfHour.enabledWorkForce">
                    </td>
                    <td  width="40%">
                        <div class="col-6 no-padding btn-inc-content">
                            <button  class="btn btn-sm btn-inc" v-bind:disabled="!voucher.quarterOfHour.enabledWorkForce" v-on:click="voucher.quarterOfHour.quantity--">-</button>
                        </div>
                        <div class="col-6 no-padding btn-inc-content">
                        <button  class="btn btn-sm btn-inc" v-bind:disabled="!voucher.quarterOfHour.enabledWorkForce" v-on:click="voucher.quarterOfHour.quantity++">+</button>
                        </div>
                    </td>
                    <td  width="20%">
                        <CurrencyInput  v-model.number="voucher.quarterOfHour.price" class="form-control" readonly="readonly"></CurrencyInput>
                    </td>

                    <td  width="10%">
                        <button v-on:click="voucher.quarterOfHour.enabledWorkForce = !voucher.quarterOfHour.enabledWorkForce" class="btn btn-sm  small-btn-with-icon"  v-bind:class="{ 'red-a': voucher.quarterOfHour.enabledWorkForce}">
                            <i class="fa fa-trash " v-if="voucher.quarterOfHour.enabledWorkForce"></i>
                            <i class="fa fa-square-o " v-if="!voucher.quarterOfHour.enabledWorkForce"></i>
                        </button>
                    </td>
                </tr>

                <!-- BY HOUR  PRICE CALCULATION -->
                <tr v-if="voucher.pricePolicyHourCalculation === 'byHour' && voucher.quarterOfHour.enabledWorkForce ">
                    <td>
                        <input type="text" v-model="voucher.byHour.title" class="form-control" v-bind:disabled="!voucher.byHour.enabledWorkForce">
                    </td>
                    <td>
                        <div class="col-6 no-padding btn-inc-content">
                            <button  class="btn btn-sm btn-inc" v-bind:disabled="!voucher.byHour.enabledWorkForce" v-on:click="voucher.byHour.quantity--">-</button>
                        </div>
                        <div class="col-6 no-padding btn-inc-content">
                            <button  class="btn btn-sm btn-inc" v-bind:disabled="!voucher.byHour.enabledWorkForce" v-on:click="voucher.byHour.quantity++">+</button>
                        </div>
                    </td>
                    <td>
                        <CurrencyInput  v-model.number="voucher.byHour.price" class="form-control" readonly="readonly"></CurrencyInput>
                    </td>

                    <td>
                        <button v-on:click="voucher.byHour.enabledWorkForce = !voucher.byHour.enabledWorkForce" class="btn btn-sm  small-btn-with-icon"  v-bind:class="{ 'red-a': voucher.byHour.enabledWorkForce}">
                            <i class="fa fa-trash " v-if="voucher.byHour.enabledWorkForce"></i>
                            <i class="fa fa-square-o " v-if="!voucher.byHour.enabledWorkForce"></i>
                        </button>
                    </td>
                </tr>

            </tbody>
        </table>

        <table class="table table-voucher" v-if="voucher.items.length > 0">
            <thead>
            <tr>
                <th width="60%">{{'Title'|trans}}</th>
                <th width="20%">{{'Price'|trans}}</th>
                <th width="10%"></th>
            </tr>
            </thead>
            <tbody>

            <template v-for="(item, index) in voucher.items">
                <tr>
                    <td>
                        <input type="text" v-model="item.title" class="form-control">
                    </td>
                    <td>
                        <CurrencyInput v-model.number="item.price" class="form-control"></CurrencyInput>
                    </td>
                    <td>
                        <button v-on:click="removeItem(index)" class="btn btn-sm red-a  small-btn-with-icon">
                            <i class="fa fa-trash "></i>
                        </button>
                    </td>
                </tr>
            </template>
            </tbody>
        </table>

        <table class="table table-striped">
            <tbody>
            <tr>
                <td width="90%">
                    <select v-model="item_template_selected" class="form-control">
                        <option  v-bind:value="null" selected="selected">
                            {{ 'Please select Item'|trans }}
                        </option>
                        <option v-for="option in item_template_choices" v-bind:value="option">
                            {{ option.title_origin }}
                        </option>
                    </select>
                </td>
                <td width="10%">
                    <button v-on:click="addItem" class="btn btn-sm btn-primary small-btn-with-icon">+</button>
                </td>
            </tr>
            </tbody>
        </table>

        <table class="table table-voucher-result">
            <tbody>
            <tr>
                <td width="60%" >
                    <select v-model="voucher.vat_regime" class="form-control">
                        <option value="21">{{'VAT'|trans}} 21%</option>
                        <option value="6">{{'VAT'|trans}} 6%</option>
                        <option value="0">{{'VAT'|trans}} 0%</option>
                        <option value="-21">{{'TVAC'|trans}} 21%</option>
                        <option value="-6">{{'TVAC'|trans}} 6%</option>
                    </select>
                </td>
                <td width="20%">{{ voucher.vat_to_pay|Round }}</td>

                <td width="10%"></td>
            </tr>
            <tr>
                <td align="right">{{'Total HTVA'|trans}}</td>
                <td>{{ voucher.total|Round }}</td>
                <td></td>
            </tr>
            <tr>
                <td align="right">{{'Total TVAC'|trans}}</td>
                <td>{{ voucher.total_vat_incl|Round }}</td>
                <td></td>
            </tr>

            </tbody>
        </table>

        <div class="col-xs-12 spacer-form">
            <button v-bind:disabled="voucher.total_vat_incl <= 0" class="btn btn-primary full-width form-control"
                    v-on:click="$emit('save')">
                {{'Save Voucher'|trans}}
            </button>
        </div>

    </div>
</template>

<script>
    import CurrencyInput from './CurrencyInput';


    export default {
        props: {
            voucher: null, // jamais de données ici
            job:null,
            isFormStepBack: false
        },
        data() {
            return {
                item_template_selected: null,
                item_template_choices: [
                    {price: null, title: this.translate("Flat rate :",  this.job.workerIntervention.customer.lang), title_origin: this.defaultTranslationItems("Flat rate :")},
                    {price: null, title: this.translate("Equipment :", this.job.workerIntervention.customer.lang), title_origin: this.defaultTranslationItems("Equipment :")},
                    {price: null, title: this.translate("Discount :", this.job.workerIntervention.customer.lang),  title_origin: this.defaultTranslationItems("Discount :")},
                    {price: null, title: this.translate("Other :", this.job.workerIntervention.customer.lang),     title_origin: this.defaultTranslationItems("Other :")},
                    {price: null, title: this.translate("Workforce :", this.job.workerIntervention.customer.lang), title_origin: this.defaultTranslationItems("Workforce :")}
                ],
                // total_vat_incl: 0,
                total: 0,
                new_item_voucher: [],
                price_for_time_of_work: 0,
                forceClickonTimes: 0,
                priceOfQuarterOfHour:35.7,
                priceOfFirstHour:null,
                priceOfShifting:80.00
            }
        },
        methods: {
            defaultTranslationItems(string){
                if(this.job.workerIntervention.customer.lang !== this.job.worker.lang) {
                    return this.translate(string)  + " (" + this.translate(string, this.job.workerIntervention.customer.lang) + ")";
                }else{
                    return this.translate(string)
                }
            },
            addItem() {
                if (this.item_template_selected !== null) {
                    if (this.item_template_selected.title === "Other") {
                        this.item_template_selected.title = '';
                    }
                    this.voucher.items.push(Object.assign({}, this.item_template_selected));
                }
                this.item_template_selected = null;
                this.new_item_voucher.title = null;
                this.new_item_voucher.price = null;
            },
            createDefaultItems() {
                this.calculateTimeOfWorkByQuarterOfHour();
                this.calculateTimeOfWorkByHour();
                this.addPriceOfShifting();
                //this.addPercentForWeekendDays();
                //this.addEveningPrice();
                //this.addNightPrice();
            },
            addPriceOfShifting(){
                /*var percentForSundayExists = this.voucher.items.find(function(element){
                    if(element.ref==="calloutprice"){
                        return true;
                    }
                });
                if(!percentForSundayExists){*/
                    const titleOfShifting = this.translate("Callout :", this.job.workerIntervention.customer.lang);
                    this.voucher.items.push({ref: 'calloutprice',price: Number(this.job.pricePolicy.calloutPrice), title: titleOfShifting, title_origin:"Callout :"});
                /*}*/
            },
            addPercentForWeekendDays(){
                const titleOfSaturdayPrice = this.translate("Saturday supplement :", this.job.workerIntervention.customer.lang);
                let percentForSaturday = {
                    ref: 'percent_saturday',
                    ignore_in_sum: true,
                    price: Number(this.job.pricePolicy.saturdayPrice),
                    percent: Number(this.job.pricePolicy.saturdayPrice),
                    title: titleOfSaturdayPrice
                };

                const titleOfSundayPrice = this.translate("Sunday supplement :", this.job.workerIntervention.customer.lang);
                let percentForSunday = {
                    ref: 'percent_sunday',
                    price: Number(this.job.pricePolicy.sundayPrice),
                    percent: Number(this.job.pricePolicy.sundayPrice),
                    ignore_in_sum: true,
                    title: titleOfSundayPrice
                }

                let percentForSaturdayExists = this.voucher.items.find(function(element){
                    if(element.ref==="percent_saturday"){
                        return true;
                    }
                });
                let percentForSundayExists = this.voucher.items.find(function(element){
                    if(element.ref==="percent_sunday"){
                        return true;
                    }
                });

                let d = new Date();
                let day = d.getDay();

                if(!percentForSundayExists && day === 7){
                    this.voucher.items.push(percentForSunday);
                }

                if(!percentForSaturdayExists && day === 6) {
                    this.voucher.items.push(percentForSaturday);
                }
                this.calculateFieldsOfPercent();
            },
            addEveningPrice(){

                const eveningPriceTitle = this.translate("Evening supplement :", this.job.workerIntervention.customer.lang);

                let percentEvening = {
                    ref: 'percent_evening',
                    price: Number(this.job.pricePolicy.eveningPrice),
                    percent: Number(this.job.pricePolicy.eveningPrice),
                    title: eveningPriceTitle
                };

                let percentEveningExists = this.voucher.items.find(function(element){
                    if(element.ref==="percent_evening"){
                        return true;
                    }
                });

                let d = new Date();
                let hour = d.getHours();
                if(!percentEveningExists && (hour >= 18 && hour <= 23)){
                    this.voucher.items.push(percentEvening);
                }

                this.calculateFieldsOfPercent();
            },
            addNightPrice(){

                const eveningPriceTitle = this.translate("Night supplement :", this.job.workerIntervention.customer.lang);

                let percentNight = {
                    ref: 'percent_night',
                    price: Number(this.job.pricePolicy.nightPrice),
                    percent: Number(this.job.pricePolicy.nightPrice),
                    title: eveningPriceTitle
                };

                let percentNightExists = this.voucher.items.find(function(element){
                    if(element.ref==="percent_night"){
                        return true;
                    }
                });

                let d = new Date();
                let hour = d.getHours();
                if(!percentNightExists && (hour >= 0 && hour < 7)){
                    this.voucher.items.push(percentNight);
                }

                this.calculateFieldsOfPercent();

            },
            calculateFieldsOfPercent(){
                this.voucher.items.forEach(function(element) {
                    if( element.ref==="percent_saturday" ||
                        element.ref==='percent_sunday' ||
                        element.ref==='percent_evening' ||
                        element.ref==='percent_night'
                    ){
                        element.price = (((this.voucher.quarterOfHour.price) / 100) * element.percent );
                        if(this.voucher.pricePolicyHourCalculation === "byHour"){
                            element.price = (((this.voucher.byHour.price) / 100) * element.percent );
                        }
                    }
                },this);
            },
            calculateTimeOfWorkByQuarterOfHour(){

                if(this.voucher.quarterOfHour.quantity <= this.job.pricePolicy.quarterHourMinimum){
                    this.voucher.quarterOfHour.quantity = this.job.pricePolicy.quarterHourMinimum;
                }

                this.price_for_time_of_work = (this.voucher.quarterOfHour.quantity * this.job.pricePolicy.quarterhourPrice);
                this.voucher.quarterOfHour.title = this.voucher.quarterOfHour.quantity + " x 1/4h";
                const workforceTranslate = this.translate("Workforce :", this.job.workerIntervention.customer.lang);
                const startedTranslate = this.translate("Started", this.job.workerIntervention.customer.lang)
                this.voucher.quarterOfHour.full_title = workforceTranslate + " : " + this.voucher.quarterOfHour.quantity + " x 1/4h "+startedTranslate+" (min "+  this.job.pricePolicy.quarterHourMinimum+"x)";

                this.voucher.quarterOfHour.price = 0;
                if (this.voucher.quarterOfHour.quantity > 0) {
                    this.voucher.quarterOfHour.price += Number(this.job.pricePolicy.firstQuarterHourPrice);
                }
                if (this.voucher.quarterOfHour.quantity > 1) {
                    this.voucher.quarterOfHour.price += (this.voucher.quarterOfHour.quantity - 1)*Number(this.job.pricePolicy.firstQuarterHourPrice);
                }
            },
            calculateTimeOfWorkByHour(){
                if (this.voucher.byHour.quantity <= 0) {
                  this.voucher.byHour.quantity=1;
                }else{
                  //this.voucher.byHour.price += (this.job.selectedSlotPrice - this.job.pricePolicy.calloutPrice)
                  this.voucher.byHour.title = this.voucher.byHour.quantity + " x 1h";
                  const workforceTranslate = this.translate("Workforce :", this.job.workerIntervention.customer.lang);
                  const startedTranslate = this.translate("Started", this.job.workerIntervention.customer.lang);
                  this.voucher.byHour.full_title = workforceTranslate + " : " + this.voucher.byHour.quantity + " x 1h " + startedTranslate + " (min " + this.job.pricePolicy.hourMinimum + "h)";

                  if (this.voucher.byHour.quantity > 0) {
                    this.voucher.byHour.price = 0;
                    this.voucher.byHour.price += (this.job.selectedSlotPrice - this.job.pricePolicy.calloutPrice) * this.voucher.byHour.quantity;
                  }
                }
            },
            removeItem(index) {
                this.voucher.items.splice(index, 1);
            },
            translate(key, language = null){
                if (language !== null) {
                    if (window.allTranslations[language][key] !== undefined ) {
                        return window.allTranslations[language][key];
                    }
                }
                if(window.translations === undefined || window.translations[key] === undefined ){
                    return key;
                }
                return window.translations[key];
            },
        },
        created() {
            if(this.isFormStepBack === false){
                this.priceOfQuarterOfHour = Number(this.job.pricePolicy.quarterhourPrice);
                this.priceOfShifting = Number(this.job.pricePolicy.calloutPrice);


                if(!isNaN(this.voucher.workTotalTimeInMinutes)){
                    this.voucher.quarterOfHour.quantity = Math.max(Math.ceil(this.voucher.workTotalTimeInMinutes / 15, 4));
                }else{
                    this.voucher.quarterOfHour.quantity = 4;
                    this.voucher.workTimeExit = new Date();
                }
                this.createDefaultItems();
                if(this.job.workerIntervention.fails.failId === 4) {
                    this.voucher.quarterOfHour.enabledWorkForce = false;
                }else{
                    this.voucher.quarterOfHour.enabledWorkForce = true;
                }

                /*
                 * Create Template items for select option
                 */
                let saturdayPrice = (((this.voucher.quarterOfHour.price) / 100) * this.job.pricePolicy.saturdayPrice);
                let sundayPrice = (((this.voucher.quarterOfHour.price) / 100) * this.job.pricePolicy.sundayPrice);
                let eveningPrice = (((this.voucher.quarterOfHour.price) / 100) * this.job.pricePolicy.eveningPrice);
                let nightPrice = (((this.voucher.quarterOfHour.price) / 100) * this.job.pricePolicy.nightPrice);

                if(this.job.pricePolicy.hourPrice > 0){
                    this.voucher.pricePolicyHourCalculation = 'byHour';
                    saturdayPrice = (((this.voucher.byHour.price) / 100) * this.job.pricePolicy.saturdayPrice);
                    sundayPrice = (((this.voucher.byHour.price) / 100) * this.job.pricePolicy.sundayPrice);
                    eveningPrice = (((this.voucher.byHour.price) / 100) * this.job.pricePolicy.eveningPrice);
                    nightPrice = (((this.voucher.byHour.price) / 100) * this.job.pricePolicy.nightPrice);
                }

                let customerLanguage = this.job.workerIntervention.customer.lang;

                let saturdaySuppPreview;
                let calloutPreview;
                let sundaySuppPreview;
                let eveningSuppPreview;
                let nightSuppPreview;

                let saturdaySupp = saturdaySuppPreview = this.translate("Saturday supplement :", customerLanguage);
                let callout      = calloutPreview = this.translate("Callout :", customerLanguage);
                let sundaySupp   = sundaySuppPreview = this.translate("Sunday supplement :", customerLanguage);
                let eveningSupp  = eveningSuppPreview = this.translate("Evening supplement :", customerLanguage);
                let nightSupp    = nightSuppPreview = this.translate("Night supplement :", customerLanguage);

                if(customerLanguage !== this.job.worker.lang){
                    saturdaySuppPreview     = this.defaultTranslationItems("Saturday supplement :");
                    calloutPreview          = this.defaultTranslationItems("Callout :");
                    sundaySuppPreview       = this.defaultTranslationItems("Sunday supplement :");
                    eveningSuppPreview      = this.defaultTranslationItems("Evening supplement :");
                    nightSuppPreview        = this.defaultTranslationItems("Night supplement :");
                }

                this.item_template_choices[4] = {
                    ref:'percent_saturday',
                    percent:Number(this.job.pricePolicy.saturdayPrice),
                    price: saturdayPrice,
                    title: saturdaySupp,
                    title_origin: saturdaySuppPreview
                };

                this.item_template_choices[2] = {
                    price: Number(this.job.pricePolicy.calloutPrice),
                    title: callout,
                    title_origin: calloutPreview
                };

                this.item_template_choices[5] = {
                    ref:'percent_sunday',
                    percent:Number(this.job.pricePolicy.sundayPrice),
                    price: sundayPrice,
                    title: sundaySupp,
                    title_origin: sundaySuppPreview
                };

                this.item_template_choices[6] = {
                    ref:'percent_evening',
                    percent:Number(this.job.pricePolicy.eveningPrice),
                    price: sundayPrice,
                    title: eveningSupp,
                    title_origin: eveningSuppPreview
                };

                this.item_template_choices[7] = {
                    ref:'percent_night',
                    percent:Number(this.job.pricePolicy.nightPrice),
                    price: nightPrice,
                    title: nightSupp,
                    title_origin: nightSuppPreview
                };
            }
        },
        watch:{
            'voucher.items': {
                handler() {
                    this.$emit('recalculatePrices');
                },
                deep: true
            },
            'voucher.vat_regime'() {
                this.$emit('recalculatePrices');
            },
            'voucher.quarterOfHour.quantity':{
                handler() {
                    this.calculateTimeOfWorkByQuarterOfHour();
                    this.calculateFieldsOfPercent();
                    this.$emit('recalculatePrices');
                },
                deep: true
            },
            'voucher.byHour.quantity':{
                handler() {
                    this.calculateTimeOfWorkByHour();
                    this.calculateFieldsOfPercent();
                    this.$emit('recalculatePrices');
                },
                deep: true
            },
            'voucher.quarterOfHour.enabledWorkForce'(){
                this.$emit('recalculatePrices');
            },
            'voucher.byHour.enabledWorkForce'(){
                this.$emit('recalculatePrices');
            },
            'voucher.isHomeMoreThanTenYears'(){
                this.$emit('recalculatePrices');
            },
            'this.voucher.items'(){
                this.$emit('recalculatePrices');
            }
        },
        computed: {

        },
        components: {
            CurrencyInput
        },
        filters: {
            Round(value) {
                if(value !== null){
                    return Math.round(value * 100) / 100;
                }
            }
        }
    }


</script>


<style lang="scss" scoped>
    .table-voucher{
        background-color: white;
        margin-bottom: 0px;
    }
     .small-btn-with-icon{
        min-height: 34px !important;
        margin:0px !important;
    }
    .table-voucher input{
        border:1px solid #e1e1dd;
        padding:2px 0px 2px 8px;
    }

    .table-voucher-result tr td,
    .table-voucher-result tr td select{
        font-size:14px;
        background-color: #ffffff;
    }

    .col-6{
        width:45%;
        float: left;
    }

    table tr td select{
        border-radius: 5px !important;
        font-size:10px !important;
    }

    #job-worker-list .quizz .btn-inc-content {
        margin:2%;
    }

    #job-worker-list .quizz button.btn-inc{
        min-height: 10px;
        background-color: #81c23f;
        color:white;
        margin:0px;
    }
    #job-worker-list .quizz button.btn-inc:hover{
        /*background-color: #96e048;*/
    }

    .white-block{
        background-color: #f8ffe4;
        padding:10px;
    }

</style>